import React, { useEffect, Children } from "react";

type Props = {
  loading?: Element;
  children?: any;
  getUserCurrentPosition?: Function;
  loaded?: boolean;
  mapEntity?: any;
  mapWrapper?: React.RefObject<HTMLDivElement>;
};

export default function AMap(props: Props) {
  const { loaded, mapEntity, mapWrapper } = props;

  function renderChildren(currentMap: any) {
    return Children.map(props.children, (child) => {
      if (child) {
        const cType = child.type;
        /* 针对下面两种组件不注入地图相关属性
         * 1. 明确声明不需要注入的
         * 2. DOM 元素
         */
        if (cType.preventAmap || typeof cType === "string") {
          return child;
        }
        return React.cloneElement(child, {
          __map__: currentMap,
          __amapui__: window.AMapUI,
        });
      }
      return child;
    });
  }

  useEffect(() => {
    return () => {
      if (mapEntity === null) return;
      // 卸载地图时释放资源
      mapEntity.destroy();
    };
  }, [mapEntity]);

  return (
    <div
      ref={mapWrapper}
      style={{ position: "relative", width: "100%", height: "100%" }}
    >
      <div ref={mapWrapper} style={{ width: "100%", height: "100%" }}>
        {loaded ? null : props.loading || null}
      </div>
      {mapEntity ? renderChildren(mapEntity) : null}
    </div>
  );
}
